import e from "react";
var d,
  n = {
    exports: {}
  },
  o = {
    exports: {}
  },
  t = {};
var r,
  i,
  a,
  l,
  s,
  _,
  m,
  c,
  u,
  v,
  p,
  h,
  f,
  O,
  L = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function x() {
  return i || (i = 1, "production" === process.env.NODE_ENV ? o.exports = function () {
    if (d) return t;
    d = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      o = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      i = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      l = e ? Symbol.for("react.provider") : 60109,
      s = e ? Symbol.for("react.context") : 60110,
      _ = e ? Symbol.for("react.async_mode") : 60111,
      m = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      u = e ? Symbol.for("react.suspense") : 60113,
      v = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      h = e ? Symbol.for("react.lazy") : 60116,
      f = e ? Symbol.for("react.block") : 60121,
      O = e ? Symbol.for("react.fundamental") : 60117,
      L = e ? Symbol.for("react.responder") : 60118,
      x = e ? Symbol.for("react.scope") : 60119;
    function y(e) {
      if ("object" == typeof e && null !== e) {
        var d = e.$$typeof;
        switch (d) {
          case n:
            switch (e = e.type) {
              case _:
              case m:
              case r:
              case a:
              case i:
              case u:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case s:
                  case c:
                  case h:
                  case p:
                  case l:
                    return e;
                  default:
                    return d;
                }
            }
          case o:
            return d;
        }
      }
    }
    function g(e) {
      return y(e) === m;
    }
    return t.AsyncMode = _, t.ConcurrentMode = m, t.ContextConsumer = s, t.ContextProvider = l, t.Element = n, t.ForwardRef = c, t.Fragment = r, t.Lazy = h, t.Memo = p, t.Portal = o, t.Profiler = a, t.StrictMode = i, t.Suspense = u, t.isAsyncMode = function (e) {
      return g(e) || y(e) === _;
    }, t.isConcurrentMode = g, t.isContextConsumer = function (e) {
      return y(e) === s;
    }, t.isContextProvider = function (e) {
      return y(e) === l;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, t.isForwardRef = function (e) {
      return y(e) === c;
    }, t.isFragment = function (e) {
      return y(e) === r;
    }, t.isLazy = function (e) {
      return y(e) === h;
    }, t.isMemo = function (e) {
      return y(e) === p;
    }, t.isPortal = function (e) {
      return y(e) === o;
    }, t.isProfiler = function (e) {
      return y(e) === a;
    }, t.isStrictMode = function (e) {
      return y(e) === i;
    }, t.isSuspense = function (e) {
      return y(e) === u;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === m || e === a || e === i || e === u || e === v || "object" == typeof e && null !== e && (e.$$typeof === h || e.$$typeof === p || e.$$typeof === l || e.$$typeof === s || e.$$typeof === c || e.$$typeof === O || e.$$typeof === L || e.$$typeof === x || e.$$typeof === f);
    }, t.typeOf = y, t;
  }() : o.exports = (r || (r = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      d = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      o = e ? Symbol.for("react.fragment") : 60107,
      t = e ? Symbol.for("react.strict_mode") : 60108,
      r = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      a = e ? Symbol.for("react.context") : 60110,
      l = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      _ = e ? Symbol.for("react.forward_ref") : 60112,
      m = e ? Symbol.for("react.suspense") : 60113,
      c = e ? Symbol.for("react.suspense_list") : 60120,
      u = e ? Symbol.for("react.memo") : 60115,
      v = e ? Symbol.for("react.lazy") : 60116,
      p = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      f = e ? Symbol.for("react.responder") : 60118,
      O = e ? Symbol.for("react.scope") : 60119;
    function x(e) {
      if ("object" == typeof e && null !== e) {
        var c = e.$$typeof;
        switch (c) {
          case d:
            var p = e.type;
            switch (p) {
              case l:
              case s:
              case o:
              case r:
              case t:
              case m:
                return p;
              default:
                var h = p && p.$$typeof;
                switch (h) {
                  case a:
                  case _:
                  case v:
                  case u:
                  case i:
                    return h;
                  default:
                    return c;
                }
            }
          case n:
            return c;
        }
      }
    }
    var y = l,
      g = s,
      b = a,
      C = i,
      E = d,
      R = _,
      w = o,
      I = v,
      M = u,
      B = n,
      H = r,
      T = t,
      N = m,
      k = !1;
    function q(e) {
      return x(e) === s;
    }
    L.AsyncMode = y, L.ConcurrentMode = g, L.ContextConsumer = b, L.ContextProvider = C, L.Element = E, L.ForwardRef = R, L.Fragment = w, L.Lazy = I, L.Memo = M, L.Portal = B, L.Profiler = H, L.StrictMode = T, L.Suspense = N, L.isAsyncMode = function (e) {
      return k || (k = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), q(e) || x(e) === l;
    }, L.isConcurrentMode = q, L.isContextConsumer = function (e) {
      return x(e) === a;
    }, L.isContextProvider = function (e) {
      return x(e) === i;
    }, L.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === d;
    }, L.isForwardRef = function (e) {
      return x(e) === _;
    }, L.isFragment = function (e) {
      return x(e) === o;
    }, L.isLazy = function (e) {
      return x(e) === v;
    }, L.isMemo = function (e) {
      return x(e) === u;
    }, L.isPortal = function (e) {
      return x(e) === n;
    }, L.isProfiler = function (e) {
      return x(e) === r;
    }, L.isStrictMode = function (e) {
      return x(e) === t;
    }, L.isSuspense = function (e) {
      return x(e) === m;
    }, L.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === s || e === r || e === t || e === m || e === c || "object" == typeof e && null !== e && (e.$$typeof === v || e.$$typeof === u || e.$$typeof === i || e.$$typeof === a || e.$$typeof === _ || e.$$typeof === h || e.$$typeof === f || e.$$typeof === O || e.$$typeof === p);
    }, L.typeOf = x;
  }()), L)), o.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function y() {
  if (l) return a;
  l = 1;
  var e = Object.getOwnPropertySymbols,
    d = Object.prototype.hasOwnProperty,
    n = Object.prototype.propertyIsEnumerable;
  return a = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var d = {}, n = 0; n < 10; n++) d["_" + String.fromCharCode(n)] = n;
      if ("0123456789" !== Object.getOwnPropertyNames(d).map(function (e) {
        return d[e];
      }).join("")) return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        o[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (o, t) {
    for (var r, i, a = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(o), l = 1; l < arguments.length; l++) {
      for (var s in r = Object(arguments[l])) d.call(r, s) && (a[s] = r[s]);
      if (e) {
        i = e(r);
        for (var _ = 0; _ < i.length; _++) n.call(r, i[_]) && (a[i[_]] = r[i[_]]);
      }
    }
    return a;
  }, a;
}
function g() {
  if (_) return s;
  _ = 1;
  return s = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function b() {
  return c ? m : (c = 1, m = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var C = x();
  n.exports = function () {
    if (h) return p;
    h = 1;
    var e = x(),
      d = y(),
      n = g(),
      o = b(),
      t = function () {
        if (v) return u;
        v = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var d = g(),
            n = {},
            o = b();
          e = function e(_e) {
            var d = "Warning: " + _e;
            "undefined" != typeof console && console.error(d);
            try {
              throw new Error(d);
            } catch (e) {}
          };
        }
        function t(t, r, i, a, l) {
          if ("production" !== process.env.NODE_ENV) for (var s in t) if (o(t, s)) {
            var _;
            try {
              if ("function" != typeof t[s]) {
                var m = Error((a || "React class") + ": " + i + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw m.name = "Invariant Violation", m;
              }
              _ = t[s](r, s, a, i, null, d);
            } catch (e) {
              _ = e;
            }
            if (!_ || _ instanceof Error || e((a || "React class") + ": type specification of " + i + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof _ + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), _ instanceof Error && !(_.message in n)) {
              n[_.message] = !0;
              var c = l ? l() : "";
              e("Failed " + i + " type: " + _.message + (null != c ? c : ""));
            }
          }
        }
        return t.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (n = {});
        }, u = t;
      }(),
      r = function r() {};
    function i() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (r = function r(e) {
      var d = "Warning: " + e;
      "undefined" != typeof console && console.error(d);
      try {
        throw new Error(d);
      } catch (e) {}
    }), p = function p(a, l) {
      var s = "function" == typeof Symbol && Symbol.iterator,
        _ = "<<anonymous>>",
        m = {
          array: p("array"),
          bigint: p("bigint"),
          bool: p("boolean"),
          func: p("function"),
          number: p("number"),
          object: p("object"),
          string: p("string"),
          symbol: p("symbol"),
          any: v(i),
          arrayOf: function arrayOf(e) {
            return v(function (d, o, t, r, i) {
              if ("function" != typeof e) return new u("Property `" + i + "` of component `" + t + "` has invalid PropType notation inside arrayOf.");
              var a = d[o];
              if (!Array.isArray(a)) return new u("Invalid " + r + " `" + i + "` of type `" + O(a) + "` supplied to `" + t + "`, expected an array.");
              for (var l = 0; l < a.length; l++) {
                var s = e(a, l, t, r, i + "[" + l + "]", n);
                if (s instanceof Error) return s;
              }
              return null;
            });
          },
          element: v(function (e, d, n, o, t) {
            var r = e[d];
            return a(r) ? null : new u("Invalid " + o + " `" + t + "` of type `" + O(r) + "` supplied to `" + n + "`, expected a single ReactElement.");
          }),
          elementType: v(function (d, n, o, t, r) {
            var i = d[n];
            return e.isValidElementType(i) ? null : new u("Invalid " + t + " `" + r + "` of type `" + O(i) + "` supplied to `" + o + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return v(function (d, n, o, t, r) {
              if (!(d[n] instanceof e)) {
                var i = e.name || _;
                return new u("Invalid " + t + " `" + r + "` of type `" + ((a = d[n]).constructor && a.constructor.name ? a.constructor.name : _) + "` supplied to `" + o + "`, expected instance of `" + i + "`.");
              }
              var a;
              return null;
            });
          },
          node: v(function (e, d, n, o, t) {
            return f(e[d]) ? null : new u("Invalid " + o + " `" + t + "` supplied to `" + n + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return v(function (d, t, r, i, a) {
              if ("function" != typeof e) return new u("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
              var l = d[t],
                s = O(l);
              if ("object" !== s) return new u("Invalid " + i + " `" + a + "` of type `" + s + "` supplied to `" + r + "`, expected an object.");
              for (var _ in l) if (o(l, _)) {
                var m = e(l, _, r, i, a + "." + _, n);
                if (m instanceof Error) return m;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? v(function (d, n, o, t, r) {
              for (var i = d[n], a = 0; a < e.length; a++) if (c(i, e[a])) return null;
              var l = JSON.stringify(e, function (e, d) {
                return "symbol" === L(d) ? String(d) : d;
              });
              return new u("Invalid " + t + " `" + r + "` of value `" + String(i) + "` supplied to `" + o + "`, expected one of " + l + ".");
            }) : ("production" !== process.env.NODE_ENV && r(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), i);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && r("Invalid argument supplied to oneOfType, expected an instance of array."), i;
            for (var d = 0; d < e.length; d++) {
              var t = e[d];
              if ("function" != typeof t) return r("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + x(t) + " at index " + d + "."), i;
            }
            return v(function (d, t, r, i, a) {
              for (var l = [], s = 0; s < e.length; s++) {
                var _ = (0, e[s])(d, t, r, i, a, n);
                if (null == _) return null;
                _.data && o(_.data, "expectedType") && l.push(_.data.expectedType);
              }
              return new u("Invalid " + i + " `" + a + "` supplied to `" + r + "`" + (l.length > 0 ? ", expected one of type [" + l.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return v(function (d, o, t, r, i) {
              var a = d[o],
                l = O(a);
              if ("object" !== l) return new u("Invalid " + r + " `" + i + "` of type `" + l + "` supplied to `" + t + "`, expected `object`.");
              for (var s in e) {
                var _ = e[s];
                if ("function" != typeof _) return h(t, r, i, s, L(_));
                var m = _(a, s, t, r, i + "." + s, n);
                if (m) return m;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return v(function (t, r, i, a, l) {
              var s = t[r],
                _ = O(s);
              if ("object" !== _) return new u("Invalid " + a + " `" + l + "` of type `" + _ + "` supplied to `" + i + "`, expected `object`.");
              var m = d({}, t[r], e);
              for (var c in m) {
                var v = e[c];
                if (o(e, c) && "function" != typeof v) return h(i, a, l, c, L(v));
                if (!v) return new u("Invalid " + a + " `" + l + "` key `" + c + "` supplied to `" + i + "`.\nBad object: " + JSON.stringify(t[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var p = v(s, c, i, a, l + "." + c, n);
                if (p) return p;
              }
              return null;
            });
          }
        };
      function c(e, d) {
        return e === d ? 0 !== e || 1 / e == 1 / d : e != e && d != d;
      }
      function u(e, d) {
        this.message = e, this.data = d && "object" == typeof d ? d : {}, this.stack = "";
      }
      function v(e) {
        if ("production" !== process.env.NODE_ENV) var d = {},
          o = 0;
        function t(t, i, a, s, m, c, v) {
          if (s = s || _, c = c || a, v !== n) {
            if (l) {
              var p = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw p.name = "Invariant Violation", p;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var h = s + ":" + a;
              !d[h] && o < 3 && (r("You are manually calling a React.PropTypes validation function for the `" + c + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), d[h] = !0, o++);
            }
          }
          return null == i[a] ? t ? null === i[a] ? new u("The " + m + " `" + c + "` is marked as required in `" + s + "`, but its value is `null`.") : new u("The " + m + " `" + c + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(i, a, s, m, c);
        }
        var i = t.bind(null, !1);
        return i.isRequired = t.bind(null, !0), i;
      }
      function p(e) {
        return v(function (d, n, o, t, r, i) {
          var a = d[n];
          return O(a) !== e ? new u("Invalid " + t + " `" + r + "` of type `" + L(a) + "` supplied to `" + o + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function h(e, d, n, o, t) {
        return new u((e || "React class") + ": " + d + " type `" + n + "." + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + t + "`.");
      }
      function f(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(f);
            if (null === e || a(e)) return !0;
            var d = function (e) {
              var d = e && (s && e[s] || e["@@iterator"]);
              if ("function" == typeof d) return d;
            }(e);
            if (!d) return !1;
            var n,
              o = d.call(e);
            if (d !== e.entries) {
              for (; !(n = o.next()).done;) if (!f(n.value)) return !1;
            } else for (; !(n = o.next()).done;) {
              var t = n.value;
              if (t && !f(t[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function O(e) {
        var d = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, d) {
          return "symbol" === e || !!d && ("Symbol" === d["@@toStringTag"] || "function" == typeof Symbol && d instanceof Symbol);
        }(d, e) ? "symbol" : d;
      }
      function L(e) {
        if (null == e) return "" + e;
        var d = O(e);
        if ("object" === d) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return d;
      }
      function x(e) {
        var d = L(e);
        switch (d) {
          case "array":
          case "object":
            return "an " + d;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + d;
          default:
            return d;
        }
      }
      return u.prototype = Error.prototype, m.checkPropTypes = t, m.resetWarningCache = t.resetWarningCache, m.PropTypes = m, m;
    }, p;
  }()(C.isElement, !0);
} else n.exports = function () {
  if (O) return f;
  O = 1;
  var e = g();
  function d() {}
  function n() {}
  return n.resetWarningCache = d, f = function f() {
    function o(d, n, o, t, r, i) {
      if (i !== e) {
        var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw a.name = "Invariant Violation", a;
      }
    }
    function t() {
      return o;
    }
    o.isRequired = o;
    var r = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: t,
      element: o,
      elementType: o,
      instanceOf: t,
      node: o,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: n,
      resetWarningCache: d
    };
    return r.PropTypes = r, r;
  };
}()();
var E = n.exports;
var R = "LiveOdds-module_Container__h9RI2",
  w = "LiveOdds-module_Title__cb70P",
  I = "LiveOdds-module_Box__HqeEo",
  M = "LiveOdds-module_CurrentOdds__m6gCb",
  B = "LiveOdds-module_OddsTitle__nZq9I",
  H = "LiveOdds-module_AwayOddsData__RGmQR",
  T = "LiveOdds-module_AwayShortName__m5tm7",
  N = "LiveOdds-module_AwayOdds__uWSFY",
  k = "LiveOdds-module_HomeOddsData__rLPks",
  q = "LiveOdds-module_HomeShortName__05cfH",
  S = "LiveOdds-module_HomeOdds__Ug8Jf",
  P = "LiveOdds-module_Divider__HqJMQ",
  A = "LiveOdds-module_Odds1__4Lzfu",
  Z = "LiveOdds-module_Odds2__LR0Vy",
  D = "LiveOdds-module_Odds3__EVOAa",
  V = "LiveOdds-module_Records__TdNkc",
  j = "LiveOdds-module_tcap__3onD4",
  $ = "LiveOdds-module_tright__UI-Qv",
  F = "LiveOdds-module_theader__PLstt",
  Q = "LiveOdds-module_BottomBox__QOrIZ",
  U = "LiveOdds-module_BetBox__Dqvp-",
  G = "LiveOdds-module_BetsTitle__WAi4h",
  z = "LiveOdds-module_AdBox__gMXUM",
  J = "LiveOdds-module_betMGM-Logo__UtJAl";
!function (e, d) {
  void 0 === d && (d = {});
  var n = d.insertAt;
  if (e && "undefined" != typeof document) {
    var o = document.head || document.getElementsByTagName("head")[0],
      t = document.createElement("style");
    t.type = "text/css", "top" === n && o.firstChild ? o.insertBefore(t, o.firstChild) : o.appendChild(t), t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
  }
}('.LiveOdds-module_Container__h9RI2 {\n  max-width: 900px;\n  height: auto;\n  position: relative;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 {\n    max-width: 100%;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Title__cb70P {\n  width: 100%;\n  text-transform: uppercase;\n  color: #343434;\n  font-size: 18px;\n  line-height: 24px;\n  font-style: italic;\n  font-family: "protipo-narrow";\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Title__cb70P {\n    max-width: 100%;\n    margin-left: 16px;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo {\n  background: #ffffff;\n  border: 1px solid #CED4DA;\n  position: relative;\n  overflow: hidden;\n  height: auto;\n  border-radius: 8px;\n  display: grid;\n  grid-template-areas: "Odds Odds Records Records" "Bet Bet Records Records";\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo {\n    grid-template-columns: none;\n  }\n}\n@media only screen and (max-width: 700px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo {\n    grid-template-columns: none;\n    grid-template-areas: none;\n    display: flex;\n    flex-direction: column;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb {\n  width: 100%;\n  height: 100px;\n  grid-area: Odds;\n  display: flex;\n  flex-direction: row;\n  justify-content: left;\n  position: relative;\n  margin-top: 16px;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb a {\n  color: inherit;\n  text-decoration: underline rgba(255, 255, 255, 0);\n  text-underline-offset: 3px;\n  transition: text-decoration 300ms ease-in-out;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb {\n    width: auto;\n    padding: 0;\n    height: 90px;\n  }\n}\n@media only screen and (max-width: 700px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb {\n    justify-content: space-evenly;\n    margin-left: 24px;\n    margin-right: 24px;\n    width: auto;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_image__lewNY {\n  position: relative;\n  top: 2px;\n}\n@media only screen and (max-width: 768px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_image__lewNY {\n    top: 0;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_OddsTitle__nZq9I {\n  font-family: "protipo-narrow";\n  font-weight: 700;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: #06192F;\n  padding-top: 8px;\n  margin-bottom: 6px;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_OddsTitle__nZq9I {\n    font-size: 14px;\n    padding-top: 0;\n    margin-bottom: 0;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayOddsData__RGmQR {\n  display: flex;\n  margin-top: 12px;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayOddsData__RGmQR .LiveOdds-module_AwayShortName__m5tm7 {\n  min-width: 36px;\n  height: 20px;\n  text-align: left;\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: 0px;\n  color: #495057;\n  text-transform: uppercase;\n  margin-right: 4px;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayOddsData__RGmQR .LiveOdds-module_AwayShortName__m5tm7 {\n    min-width: 46px;\n    font-size: 13px;\n  }\n}\n@media (hover: hover) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayOddsData__RGmQR .LiveOdds-module_AwayShortName__m5tm7 a:hover {\n    text-decoration: underline;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayOddsData__RGmQR .LiveOdds-module_AwayOdds__uWSFY {\n  width: 40px;\n  height: 20px;\n  text-align: right;\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0px;\n  color: #06192F;\n  text-transform: uppercase;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayOddsData__RGmQR .LiveOdds-module_AwayOdds__uWSFY {\n    width: 30px;\n    font-size: 13px;\n  }\n}\n@media (hover: hover) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayOddsData__RGmQR .LiveOdds-module_AwayOdds__uWSFY a:hover {\n    text-decoration: underline;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeOddsData__rLPks {\n  display: flex;\n  margin-top: 5px;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeOddsData__rLPks .LiveOdds-module_HomeShortName__05cfH {\n  min-width: 36px;\n  height: 20px;\n  text-align: left;\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: 0px;\n  color: #495057;\n  text-transform: uppercase;\n  margin-right: 4px;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeOddsData__rLPks .LiveOdds-module_HomeShortName__05cfH {\n    min-width: 46px;\n  }\n}\n@media (hover: hover) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeOddsData__rLPks .LiveOdds-module_HomeShortName__05cfH a:hover {\n    text-decoration: underline;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeOddsData__rLPks .LiveOdds-module_HomeOdds__Ug8Jf {\n  width: 40px;\n  height: 20px;\n  text-align: right;\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 22px;\n  letter-spacing: 0px;\n  color: #06192F;\n  text-transform: uppercase;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeOddsData__rLPks .LiveOdds-module_HomeOdds__Ug8Jf {\n    width: 30px;\n  }\n}\n@media (hover: hover) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeOddsData__rLPks .LiveOdds-module_HomeOdds__Ug8Jf a:hover {\n    text-decoration: underline;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_Divider__HqJMQ {\n  display: none;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_Divider__HqJMQ {\n    display: block;\n    border-left: 1px solid #CED4DA;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb > div + div {\n  border-left: 1px solid #CED4DA;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb > div + div {\n    border-left: none;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb > div:not(.LiveOdds-module_Divider__HqJMQ) {\n  position: relative;\n  padding-left: 24px;\n  padding-right: 24px;\n  padding-bottom: 3px;\n}\n@media only screen and (max-width: 700px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb > div:not(.LiveOdds-module_Divider__HqJMQ) {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n}\n@media only screen and (max-width: 400px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb > div:not(.LiveOdds-module_Divider__HqJMQ) {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_Odds1__4Lzfu {\n  display: flex;\n  flex-direction: column;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_Odds1__4Lzfu {\n    max-width: 33.33%;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_Odds2__LR0Vy {\n  display: flex;\n  flex-direction: column;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_Odds2__LR0Vy {\n    max-width: 33.33%;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_Odds3__EVOAa {\n  display: flex;\n  flex-direction: column;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_Odds3__EVOAa {\n    max-width: 33.33%;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc {\n  position: relative;\n  grid-area: Records;\n  margin: 0 24px 0 24px;\n}\n@media only screen and (max-width: 767px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc {\n    margin: 0 24px 0 0;\n  }\n}\n@media only screen and (max-width: 700px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc {\n    display: none;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table {\n  font-family: "protipo-narrow";\n  width: 100%;\n  border-spacing: 0;\n  margin-top: 16px;\n  margin-bottom: 24px;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr th {\n  font-weight: 700;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr th.LiveOdds-module_tcap__3onD4 {\n  text-transform: uppercase;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr th.LiveOdds-module_tright__UI-Qv {\n  text-align: right;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr th:nth-child(2n) {\n  width: 160px;\n  text-align: center;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr th:nth-child(2n) {\n    width: 120px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr th:nth-child(2n) {\n    width: 90px;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr th:nth-child(3n):not(.LiveOdds-module_tright__UI-Qv) {\n  text-align: center;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr td:last-child, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr th:last-child {\n  width: 65px;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr th:first-child, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr td:first-child {\n  text-align: left;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr.LiveOdds-module_theader__PLstt {\n  color: #06192F;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr.LiveOdds-module_theader__PLstt th, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr.LiveOdds-module_theader__PLstt td {\n  font-size: 16px;\n  line-height: 38px;\n  border-bottom: 1px solid #CED4DA;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr.LiveOdds-module_theader__PLstt th > img, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr.LiveOdds-module_theader__PLstt td > img {\n  width: auto;\n  height: 20px;\n  vertical-align: -4px;\n  margin-right: 5px;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr.LiveOdds-module_theader__PLstt th, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr.LiveOdds-module_theader__PLstt td {\n    padding-bottom: 8px;\n    font-size: 14px;\n    line-height: 22px;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr:nth-child(n+2) td, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr:nth-child(n+2) th {\n  padding-top: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #CED4DA;\n  font-size: 14px;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr:nth-child(n+2) td, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr:nth-child(n+2) th {\n    padding-top: 12px;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr:nth-child(n+2) td {\n  color: #212529;\n  font-weight: 500;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr:nth-child(n+2) th {\n  color: #06192F;\n  font-weight: 700;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr:last-child td, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_Records__TdNkc table tr:last-child th {\n  border-bottom: none;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ {\n  grid-area: Bet;\n  display: flex;\n  margin: 34px 24px 24px 24px;\n}\n@media only screen and (max-width: 1199px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ {\n    margin-top: 16px;\n    justify-content: left;\n  }\n}\n@media only screen and (max-width: 700px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ {\n    justify-content: center;\n  }\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ .LiveOdds-module_BetBox__Dqvp- {\n  width: 140px;\n  height: 44px;\n  display: flex;\n  background: #005eb8 0% 0% no-repeat padding-box;\n  border-radius: 4px;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 24px;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ .LiveOdds-module_BetBox__Dqvp- a {\n  text-decoration: none;\n  display: flex;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ .LiveOdds-module_BetBox__Dqvp- .LiveOdds-module_BetsTitle__WAi4h {\n  height: 20px;\n  text-align: center;\n  font: normal normal bold 16px/22px "protipo-narrow";\n  letter-spacing: 0px;\n  color: #ffffff;\n  opacity: 1;\n  text-transform: capitalize;\n  margin-right: 8px;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ .LiveOdds-module_AdBox__gMXUM {\n  text-align: left;\n  font: normal normal normal 12px/14px "protipo-narrow";\n  font-weight: 500;\n  letter-spacing: 0px;\n  color: #ADB5BD;\n  opacity: 1;\n  display: flex;\n  flex-direction: column;\n  line-height: 1;\n  justify-content: flex-end;\n}\n.LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ .LiveOdds-module_AdBox__gMXUM .LiveOdds-module_betMGM-Logo__UtJAl {\n  display: inline-block;\n  margin-top: 12px;\n  width: 150px;\n  height: 42.6px;\n  background: url(\'data:image/svg+xml,<%3Fxml version="1.0" encoding="UTF-8"%3F><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 150 42.6"><defs><style> .cls-1 { fill: %23c0a971; } .cls-2 { fill: %23fff; } </style></defs>\x3c!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142) --\x3e<g><g id="Layer_1"><g id="Layer_1-2" data-name="Layer_1"><g id="Layer_2"><g id="logo_outline"><rect class="cls-1" x=".6" y=".6" width="41.2" height="41.4"/><path class="cls-1" d="M41.2,1.3v40.1H1.3V1.3h39.9M42.6,0H0v42.6h42.6V0Z"/><path class="cls-2" d="M61.6,25c0,2.7-2,4.3-6,4.3h-7.4V13.2h6.9c3.6,0,5.6,1.5,5.6,4.1s-1,3.1-2.5,3.6c2.1.4,3.3,1.8,3.3,4h.1ZM49.8,14.6v5.8h5.1c2.6,0,4.1-1,4.1-2.9s-1.5-2.9-4.1-2.9c0,0-5.1,0-5.1,0ZM59.9,24.9c0-2.1-1.5-3-4.4-3h-5.7v6h5.7c2.8,0,4.4-.9,4.4-3h0Z"/><path class="cls-2" d="M75.5,27.8v1.5h-11.4V13.2h11v1.5h-9.3v5.7h8.3v1.4h-8.3v6h9.7Z"/><path class="cls-2" d="M82.6,14.7h-5.6v-1.5h13v1.5h-5.6v14.6h-1.7v-14.6h-.1Z"/><path class="cls-2" d="M106.2,29.3v-8.5l-4.2,6.9h-2l-4.1-6.7v8.3h-4.2V13.2h3.7l5.6,9.3,5.5-9.3h3.7v16.1h-4.1,0Z"/><path class="cls-2" d="M124.4,20.9h4v6.7c-1.9,1.3-4.4,2.1-6.7,2.1-5.1,0-8.9-3.5-8.9-8.4s3.7-8.4,9-8.4,5.5,1,7,2.9l-2.9,2.6c-1.1-1.2-2.4-1.8-3.9-1.8-2.8,0-4.6,1.8-4.6,4.6s1.8,4.6,4.5,4.6,1.7-.2,2.5-.5v-4.4h0Z"/><path class="cls-2" d="M145.8,29.3v-8.5l-4.2,6.9h-2l-4.1-6.7v8.3h-4.2V13.2h3.7l5.6,9.3,5.5-9.3h3.7v16.1h-4.1.1Z"/><path d="M3.2,17.7c0,3.5.6,6.8,2.4,9.6v-2.4c0-2.9,2.4-5,4.8-6.4-2.5.9-5.2.3-7.2-.8"/><path d="M5.3,15.2h-.8c0-.5,1.1-1.3,1.5-.7l-.7.7ZM2.8,14.8c.8.5,1.7.7,2.6.6.8.6,1.9-1,3.1-1,1.7-.2,3.9-.5,5,1l-.6-1.1c-1.6-.1-3-.7-4.2-1.4-2.5-1.1-3.7,2.5-5.9,2"/><path d="M1.3,9c.8.2,1.6.5,2.4.5,1.7-.7,2.2-2.1,1.5-3.9-.9-1.3-2.3-2.3-3.9-2.6,0,0,0,6,0,6Z"/><path d="M12.7,41.4c.3-.3.6-.6.8-.9,4.6-5.9-4.3-9.4-4.1-15,.2-2.3,1.5-4,2.9-5.8h-.1c-1.4,1.3-1.9,2.1-2.9,3.5-2.7,5.6,1.1,13.3-2.9,18.1l6.2.2h.1Z"/><path d="M31.1,21.3c0,8.2-3.9,15.4-9.9,20h20V1.3h-20c6.3,4.8,9.9,12.2,9.9,20"/><path d="M1.3,41.4h3.4l.8-.8c4.7-6.4-.9-10.8-4.3-15.8v16.6h.1Z"/><path d="M10.7,1.3H1.3v.7c1,.2,1.9.4,2.7.8,1.9,1.1,3.4,3,3.2,5.2l4.2-.5c.6-1.4.8-3.5.2-4.7-.2-.6-.5-1.1-.9-1.6"/><path d="M12.7,1.3c.9,1.3.9,2.9,1,4.1,1.7-1.3,3.8-2.1,5.9-1.5-1.5-1.1-2.5-2.1-4.3-2.7h-2.6Z"/><path d="M21.1,21.7l-.3.9-.5-1.1c-1,.2-2.1.6-2.6,1.7-.1.3.1.9-.2,1.1-.7-.1-.3-1.3-.3-1.9.8-.8,2.9-2.5,3.8-1.8.2,0,.3.6.2,1.1M16.6,29.9c-.6-.5-.3-1.3-.3-1.8l.3-.3c.6,1.8,2.1-.3,3.2-.1.6-.2.3-1,.9-.9.9,2.9-2.5,2.3-4.1,3.2M24.7,30.2c.5-3.8.1-7.8-2.6-10.4-.6-.1-1.4.2-1.8-.3-1.3,1.1-2.9,1.6-4,2.9-1.3.3-2.5-.5-3.8-.7v-.5c-1.7,1.1-1.3,3.4-1.6,5.1.5,1.9,2.6,2.7,4,3.9,2.2.3,4.1-.6,5.9-1.3.3.3.8.6.6,1-1.5,2.1-3.6,3-6.1,2.7,1.5,2.9.5,6.1-1.1,8.6h1.5c4.5-2,8.7-5.2,9.1-11.1"/><path d="M28.1,14.8c-1.3-4.3-5.1-10.1-10.2-9.8-1.9,0-3.9,1.6-4.5,2.7,1.5.9,2.9,1.9,4.1,3.1-.1.5.2,1-.3,1.3-.7-.6-1.3-1.9-2.2-1.5.7,1.5,2.5,1.6,3.9,1.9.6.6.3,1.5,1.5,1,.6.1.8.8.9,1.3-.9,1.7-3.4.6-4.8.9,1.1.5,2.4.6,3.4,1.3,1,.7,1.4-.9,1.8-1.5,1.8.5.8,2.4,1.6,3.4,3.9,4,3.1,11,1.1,15.6,5.4-4.7,4.9-15.4,3.8-19.7"/></g></g><g id="Layer_2-2"><g id="logo_outline-2"><rect class="cls-1" x=".6" y=".6" width="41.2" height="41.4"/><path class="cls-1" d="M41.2,1.3v40.1H1.3V1.3h39.9M42.6,0H0v42.6h42.6V0Z"/><path d="M61.6,25c0,2.7-2,4.3-6,4.3h-7.4V13.2h6.9c3.6,0,5.6,1.5,5.6,4.1s-1,3.1-2.5,3.6c2.1.4,3.3,1.8,3.3,4h.1ZM49.8,14.6v5.8h5.1c2.6,0,4.1-1,4.1-2.9s-1.5-2.9-4.1-2.9c0,0-5.1,0-5.1,0ZM59.9,24.9c0-2.1-1.5-3-4.4-3h-5.7v6h5.7c2.8,0,4.4-.9,4.4-3h0Z"/><path d="M75.5,27.8v1.5h-11.4V13.2h11v1.5h-9.3v5.7h8.3v1.4h-8.3v6h9.7Z"/><path d="M82.6,14.7h-5.6v-1.5h13v1.5h-5.6v14.6h-1.7v-14.6h-.1Z"/><path d="M106.2,29.3v-8.5l-4.2,6.9h-2l-4.1-6.7v8.3h-4.2V13.2h3.7l5.6,9.3,5.5-9.3h3.7v16.1h-4.1,0Z"/><path d="M124.4,20.9h4v6.7c-1.9,1.3-4.4,2.1-6.7,2.1-5.1,0-8.9-3.5-8.9-8.4s3.7-8.4,9-8.4,5.5,1,7,2.9l-2.9,2.6c-1.1-1.2-2.4-1.8-3.9-1.8-2.8,0-4.6,1.8-4.6,4.6s1.8,4.6,4.5,4.6,1.7-.2,2.5-.5v-4.4h0Z"/><path d="M145.8,29.3v-8.5l-4.2,6.9h-2l-4.1-6.7v8.3h-4.2V13.2h3.7l5.6,9.3,5.5-9.3h3.7v16.1h-4.1.1Z"/><path d="M3.2,17.7c0,3.5.6,6.8,2.4,9.6v-2.4c0-2.9,2.4-5,4.8-6.4-2.5.9-5.2.3-7.2-.8"/><path d="M5.3,15.2h-.8c0-.5,1.1-1.3,1.5-.7l-.7.7ZM2.8,14.8c.8.5,1.7.7,2.6.6.8.6,1.9-1,3.1-1,1.7-.2,3.9-.5,5,1l-.6-1.1c-1.6-.1-3-.7-4.2-1.4-2.5-1.1-3.7,2.5-5.9,2"/><path d="M1.3,9c.8.2,1.6.5,2.4.5,1.7-.7,2.2-2.1,1.5-3.9-.9-1.3-2.3-2.3-3.9-2.6,0,0,0,6,0,6Z"/><path d="M12.7,41.4c.3-.3.6-.6.8-.9,4.6-5.9-4.3-9.4-4.1-15,.2-2.3,1.5-4,2.9-5.8h-.1c-1.4,1.3-1.9,2.1-2.9,3.5-2.7,5.6,1.1,13.3-2.9,18.1l6.2.2h.1Z"/><path d="M31.1,21.3c0,8.2-3.9,15.4-9.9,20h20V1.3h-20c6.3,4.8,9.9,12.2,9.9,20"/><path d="M1.3,41.4h3.4l.8-.8c4.7-6.4-.9-10.8-4.3-15.8v16.6h.1Z"/><path d="M10.7,1.3H1.3v.7c1,.2,1.9.4,2.7.8,1.9,1.1,3.4,3,3.2,5.2l4.2-.5c.6-1.4.8-3.5.2-4.7-.2-.6-.5-1.1-.9-1.6"/><path d="M12.7,1.3c.9,1.3.9,2.9,1,4.1,1.7-1.3,3.8-2.1,5.9-1.5-1.5-1.1-2.5-2.1-4.3-2.7h-2.6Z"/><path d="M21.1,21.7l-.3.9-.5-1.1c-1,.2-2.1.6-2.6,1.7-.1.3.1.9-.2,1.1-.7-.1-.3-1.3-.3-1.9.8-.8,2.9-2.5,3.8-1.8.2,0,.3.6.2,1.1M16.6,29.9c-.6-.5-.3-1.3-.3-1.8l.3-.3c.6,1.8,2.1-.3,3.2-.1.6-.2.3-1,.9-.9.9,2.9-2.5,2.3-4.1,3.2M24.7,30.2c.5-3.8.1-7.8-2.6-10.4-.6-.1-1.4.2-1.8-.3-1.3,1.1-2.9,1.6-4,2.9-1.3.3-2.5-.5-3.8-.7v-.5c-1.7,1.1-1.3,3.4-1.6,5.1.5,1.9,2.6,2.7,4,3.9,2.2.3,4.1-.6,5.9-1.3.3.3.8.6.6,1-1.5,2.1-3.6,3-6.1,2.7,1.5,2.9.5,6.1-1.1,8.6h1.5c4.5-2,8.7-5.2,9.1-11.1"/><path d="M28.1,14.8c-1.3-4.3-5.1-10.1-10.2-9.8-1.9,0-3.9,1.6-4.5,2.7,1.5.9,2.9,1.9,4.1,3.1-.1.5.2,1-.3,1.3-.7-.6-1.3-1.9-2.2-1.5.7,1.5,2.5,1.6,3.9,1.9.6.6.3,1.5,1.5,1,.6.1.8.8.9,1.3-.9,1.7-3.4.6-4.8.9,1.1.5,2.4.6,3.4,1.3,1,.7,1.4-.9,1.8-1.5,1.8.5.8,2.4,1.6,3.4,3.9,4,3.1,11,1.1,15.6,5.4-4.7,4.9-15.4,3.8-19.7"/></g></g></g></g></g></svg>\') no-repeat;\n}\n@media only screen and (max-width: 700px) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ .LiveOdds-module_AdBox__gMXUM {\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_BottomBox__QOrIZ .LiveOdds-module_AdBox__gMXUM .LiveOdds-module_betMGM-Logo__UtJAl {\n    margin-top: 0;\n    margin-left: 16px;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Title__cb70P {\n    color: #ffffff;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo {\n    background: #1D2F43;\n    border-color: #CED4DA;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_OddsTitle__nZq9I {\n    color: #ffffff;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayShortName__m5tm7, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeShortName__05cfH {\n    color: #CED4DA !important;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeOdds__Ug8Jf, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayOdds__uWSFY {\n    color: #ffffff !important;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb div + div {\n    border-left-color: #495057 !important;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_BottomBox__QOrIZ .LiveOdds-module_AdBox__gMXUM .LiveOdds-module_betMGM-Logo__UtJAl {\n    background: url(\'data:image/svg+xml,<%3Fxml version="1.0" encoding="UTF-8"%3F><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 150 42.6"><defs><style> .cls-1 { fill: %23c0a971; } .cls-2 { fill: %23fff; } </style></defs>\x3c!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142) --\x3e<g><g id="BetMGMDark"><rect class="cls-1" x=".6" y=".6" width="41.2" height="41.4"/><path class="cls-1" d="M41.2,1.3v40.1H1.3V1.3h39.9M42.6,0H0v42.6h42.6V0Z"/><path class="cls-2" d="M61.6,25c0,2.7-2,4.3-6,4.3h-7.4V13.2h6.9c3.6,0,5.6,1.5,5.6,4.1s-1,3.1-2.5,3.6c2.1.4,3.3,1.8,3.3,4h.1ZM49.8,14.6v5.8h5.1c2.6,0,4.1-1,4.1-2.9s-1.5-2.9-4.1-2.9c0,0-5.1,0-5.1,0ZM59.9,24.9c0-2.1-1.5-3-4.4-3h-5.7v6h5.7c2.8,0,4.4-.9,4.4-3h0Z"/><path class="cls-2" d="M75.5,27.8v1.5h-11.4V13.2h11v1.5h-9.3v5.7h8.3v1.4h-8.3v6h9.7Z"/><path class="cls-2" d="M82.6,14.7h-5.6v-1.5h13v1.5h-5.6v14.6h-1.7v-14.6h-.1Z"/><path class="cls-2" d="M106.2,29.3v-8.5l-4.2,6.9h-2l-4.1-6.7v8.3h-4.2V13.2h3.7l5.6,9.3,5.5-9.3h3.7v16.1h-4.1,0Z"/><path class="cls-2" d="M124.4,20.9h4v6.7c-1.9,1.3-4.4,2.1-6.7,2.1-5.1,0-8.9-3.5-8.9-8.4s3.7-8.4,9-8.4,5.5,1,7,2.9l-2.9,2.6c-1.1-1.2-2.4-1.8-3.9-1.8-2.8,0-4.6,1.8-4.6,4.6s1.8,4.6,4.5,4.6,1.7-.2,2.5-.5v-4.4h0Z"/><path class="cls-2" d="M145.8,29.3v-8.5l-4.2,6.9h-2l-4.1-6.7v8.3h-4.2V13.2h3.7l5.6,9.3,5.5-9.3h3.7v16.1h-4.1.1Z"/><path d="M3.2,17.7c0,3.5.6,6.8,2.4,9.6v-2.4c0-2.9,2.4-5,4.8-6.4-2.5.9-5.2.3-7.2-.8"/><path d="M5.3,15.2h-.8c0-.5,1.1-1.3,1.5-.7l-.7.7ZM2.8,14.8c.8.5,1.7.7,2.6.6.8.6,1.9-1,3.1-1,1.7-.2,3.9-.5,5,1l-.6-1.1c-1.6-.1-3-.7-4.2-1.4-2.5-1.1-3.7,2.5-5.9,2"/><path d="M1.3,9c.8.2,1.6.5,2.4.5,1.7-.7,2.2-2.1,1.5-3.9-.9-1.3-2.3-2.3-3.9-2.6,0,0,0,6,0,6Z"/><path d="M12.7,41.4c.3-.3.6-.6.8-.9,4.6-5.9-4.3-9.4-4.1-15,.2-2.3,1.5-4,2.9-5.8h-.1c-1.4,1.3-1.9,2.1-2.9,3.5-2.7,5.6,1.1,13.3-2.9,18.1l6.2.2h.1Z"/><path d="M31.1,21.3c0,8.2-3.9,15.4-9.9,20h20V1.3h-20c6.3,4.8,9.9,12.2,9.9,20"/><path d="M1.3,41.4h3.4l.8-.8c4.7-6.4-.9-10.8-4.3-15.8v16.6h.1Z"/><path d="M10.7,1.3H1.3v.7c1,.2,1.9.4,2.7.8,1.9,1.1,3.4,3,3.2,5.2l4.2-.5c.6-1.4.8-3.5.2-4.7-.2-.6-.5-1.1-.9-1.6"/><path d="M12.7,1.3c.9,1.3.9,2.9,1,4.1,1.7-1.3,3.8-2.1,5.9-1.5-1.5-1.1-2.5-2.1-4.3-2.7h-2.6Z"/><path d="M21.1,21.7l-.3.9-.5-1.1c-1,.2-2.1.6-2.6,1.7-.1.3.1.9-.2,1.1-.7-.1-.3-1.3-.3-1.9.8-.8,2.9-2.5,3.8-1.8.2,0,.3.6.2,1.1M16.6,29.9c-.6-.5-.3-1.3-.3-1.8l.3-.3c.6,1.8,2.1-.3,3.2-.1.6-.2.3-1,.9-.9.9,2.9-2.5,2.3-4.1,3.2M24.7,30.2c.5-3.8.1-7.8-2.6-10.4-.6-.1-1.4.2-1.8-.3-1.3,1.1-2.9,1.6-4,2.9-1.3.3-2.5-.5-3.8-.7v-.5c-1.7,1.1-1.3,3.4-1.6,5.1.5,1.9,2.6,2.7,4,3.9,2.2.3,4.1-.6,5.9-1.3.3.3.8.6.6,1-1.5,2.1-3.6,3-6.1,2.7,1.5,2.9.5,6.1-1.1,8.6h1.5c4.5-2,8.7-5.2,9.1-11.1"/><path d="M28.1,14.8c-1.3-4.3-5.1-10.1-10.2-9.8-1.9,0-3.9,1.6-4.5,2.7,1.5.9,2.9,1.9,4.1,3.1-.1.5.2,1-.3,1.3-.7-.6-1.3-1.9-2.2-1.5.7,1.5,2.5,1.6,3.9,1.9.6.6.3,1.5,1.5,1,.6.1.8.8.9,1.3-.9,1.7-3.4.6-4.8.9,1.1.5,2.4.6,3.4,1.3,1,.7,1.4-.9,1.8-1.5,1.8.5.8,2.4,1.6,3.4,3.9,4,3.1,11,1.1,15.6,5.4-4.7,4.9-15.4,3.8-19.7"/></g></g></svg>\') no-repeat !important;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Records__TdNkc table tr th {\n    color: #ffffff !important;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Records__TdNkc table tr td {\n    color: #CED4DA !important;\n  }\n  .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Records__TdNkc table tr th, .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Records__TdNkc table tr td {\n    border-bottom-color: #495057 !important;\n  }\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Title__cb70P {\n  color: #ffffff;\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo {\n  background: #1D2F43;\n  border-color: #CED4DA;\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_OddsTitle__nZq9I {\n  color: #ffffff;\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayShortName__m5tm7, .darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeShortName__05cfH {\n  color: #CED4DA !important;\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_HomeOdds__Ug8Jf, .darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb .LiveOdds-module_AwayOdds__uWSFY {\n  color: #ffffff !important;\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Box__HqeEo .LiveOdds-module_CurrentOdds__m6gCb div + div {\n  border-left-color: #495057 !important;\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_BottomBox__QOrIZ .LiveOdds-module_AdBox__gMXUM .LiveOdds-module_betMGM-Logo__UtJAl {\n  background: url(\'data:image/svg+xml,<%3Fxml version="1.0" encoding="UTF-8"%3F><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 150 42.6"><defs><style> .cls-1 { fill: %23c0a971; } .cls-2 { fill: %23fff; } </style></defs>\x3c!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142) --\x3e<g><g id="BetMGMDark"><rect class="cls-1" x=".6" y=".6" width="41.2" height="41.4"/><path class="cls-1" d="M41.2,1.3v40.1H1.3V1.3h39.9M42.6,0H0v42.6h42.6V0Z"/><path class="cls-2" d="M61.6,25c0,2.7-2,4.3-6,4.3h-7.4V13.2h6.9c3.6,0,5.6,1.5,5.6,4.1s-1,3.1-2.5,3.6c2.1.4,3.3,1.8,3.3,4h.1ZM49.8,14.6v5.8h5.1c2.6,0,4.1-1,4.1-2.9s-1.5-2.9-4.1-2.9c0,0-5.1,0-5.1,0ZM59.9,24.9c0-2.1-1.5-3-4.4-3h-5.7v6h5.7c2.8,0,4.4-.9,4.4-3h0Z"/><path class="cls-2" d="M75.5,27.8v1.5h-11.4V13.2h11v1.5h-9.3v5.7h8.3v1.4h-8.3v6h9.7Z"/><path class="cls-2" d="M82.6,14.7h-5.6v-1.5h13v1.5h-5.6v14.6h-1.7v-14.6h-.1Z"/><path class="cls-2" d="M106.2,29.3v-8.5l-4.2,6.9h-2l-4.1-6.7v8.3h-4.2V13.2h3.7l5.6,9.3,5.5-9.3h3.7v16.1h-4.1,0Z"/><path class="cls-2" d="M124.4,20.9h4v6.7c-1.9,1.3-4.4,2.1-6.7,2.1-5.1,0-8.9-3.5-8.9-8.4s3.7-8.4,9-8.4,5.5,1,7,2.9l-2.9,2.6c-1.1-1.2-2.4-1.8-3.9-1.8-2.8,0-4.6,1.8-4.6,4.6s1.8,4.6,4.5,4.6,1.7-.2,2.5-.5v-4.4h0Z"/><path class="cls-2" d="M145.8,29.3v-8.5l-4.2,6.9h-2l-4.1-6.7v8.3h-4.2V13.2h3.7l5.6,9.3,5.5-9.3h3.7v16.1h-4.1.1Z"/><path d="M3.2,17.7c0,3.5.6,6.8,2.4,9.6v-2.4c0-2.9,2.4-5,4.8-6.4-2.5.9-5.2.3-7.2-.8"/><path d="M5.3,15.2h-.8c0-.5,1.1-1.3,1.5-.7l-.7.7ZM2.8,14.8c.8.5,1.7.7,2.6.6.8.6,1.9-1,3.1-1,1.7-.2,3.9-.5,5,1l-.6-1.1c-1.6-.1-3-.7-4.2-1.4-2.5-1.1-3.7,2.5-5.9,2"/><path d="M1.3,9c.8.2,1.6.5,2.4.5,1.7-.7,2.2-2.1,1.5-3.9-.9-1.3-2.3-2.3-3.9-2.6,0,0,0,6,0,6Z"/><path d="M12.7,41.4c.3-.3.6-.6.8-.9,4.6-5.9-4.3-9.4-4.1-15,.2-2.3,1.5-4,2.9-5.8h-.1c-1.4,1.3-1.9,2.1-2.9,3.5-2.7,5.6,1.1,13.3-2.9,18.1l6.2.2h.1Z"/><path d="M31.1,21.3c0,8.2-3.9,15.4-9.9,20h20V1.3h-20c6.3,4.8,9.9,12.2,9.9,20"/><path d="M1.3,41.4h3.4l.8-.8c4.7-6.4-.9-10.8-4.3-15.8v16.6h.1Z"/><path d="M10.7,1.3H1.3v.7c1,.2,1.9.4,2.7.8,1.9,1.1,3.4,3,3.2,5.2l4.2-.5c.6-1.4.8-3.5.2-4.7-.2-.6-.5-1.1-.9-1.6"/><path d="M12.7,1.3c.9,1.3.9,2.9,1,4.1,1.7-1.3,3.8-2.1,5.9-1.5-1.5-1.1-2.5-2.1-4.3-2.7h-2.6Z"/><path d="M21.1,21.7l-.3.9-.5-1.1c-1,.2-2.1.6-2.6,1.7-.1.3.1.9-.2,1.1-.7-.1-.3-1.3-.3-1.9.8-.8,2.9-2.5,3.8-1.8.2,0,.3.6.2,1.1M16.6,29.9c-.6-.5-.3-1.3-.3-1.8l.3-.3c.6,1.8,2.1-.3,3.2-.1.6-.2.3-1,.9-.9.9,2.9-2.5,2.3-4.1,3.2M24.7,30.2c.5-3.8.1-7.8-2.6-10.4-.6-.1-1.4.2-1.8-.3-1.3,1.1-2.9,1.6-4,2.9-1.3.3-2.5-.5-3.8-.7v-.5c-1.7,1.1-1.3,3.4-1.6,5.1.5,1.9,2.6,2.7,4,3.9,2.2.3,4.1-.6,5.9-1.3.3.3.8.6.6,1-1.5,2.1-3.6,3-6.1,2.7,1.5,2.9.5,6.1-1.1,8.6h1.5c4.5-2,8.7-5.2,9.1-11.1"/><path d="M28.1,14.8c-1.3-4.3-5.1-10.1-10.2-9.8-1.9,0-3.9,1.6-4.5,2.7,1.5.9,2.9,1.9,4.1,3.1-.1.5.2,1-.3,1.3-.7-.6-1.3-1.9-2.2-1.5.7,1.5,2.5,1.6,3.9,1.9.6.6.3,1.5,1.5,1,.6.1.8.8.9,1.3-.9,1.7-3.4.6-4.8.9,1.1.5,2.4.6,3.4,1.3,1,.7,1.4-.9,1.8-1.5,1.8.5.8,2.4,1.6,3.4,3.9,4,3.1,11,1.1,15.6,5.4-4.7,4.9-15.4,3.8-19.7"/></g></g></svg>\') no-repeat !important;\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Records__TdNkc table tr th {\n  color: #ffffff !important;\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Records__TdNkc table tr td {\n  color: #CED4DA !important;\n}\n.darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Records__TdNkc table tr th, .darkMode .LiveOdds-module_Container__h9RI2 .LiveOdds-module_Records__TdNkc table tr td {\n  border-bottom-color: #495057 !important;\n}');
var W = function W(d) {
  var n = d.title,
    o = d.ctaText,
    t = d.ctaLink,
    r = d.OddsTitle1,
    i = d.OddsTitle2,
    a = d.OddsTitle3,
    l = d.AwayShortName1,
    s = d.AwayShortName2,
    _ = d.AwayShortName3,
    m = d.AwayOdds1,
    c = d.AwayOdds2,
    u = d.AwayOdds3,
    v = d.HomeShortName1,
    p = d.HomeShortName2,
    h = d.HomeShortName3,
    f = d.HomeOdds1,
    O = d.HomeOdds2,
    L = d.HomeOdds3,
    x = d.recordHomeTitle,
    y = d.recordAwayTitle,
    g = d.recordData,
    b = d.deepLink;
  return e.createElement("div", {
    className: R
  }, n && e.createElement("div", {
    className: w
  }, n), e.createElement("div", {
    className: I
  }, e.createElement("div", {
    className: M
  }, e.createElement("div", {
    className: A
  }, e.createElement("div", {
    className: B
  }, e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, r)), e.createElement("div", {
    className: H
  }, e.createElement("div", {
    className: T
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, l) : e.createElement(e.Fragment, null, l)), e.createElement("div", {
    className: N
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, m) : e.createElement(e.Fragment, null, m))), e.createElement("div", {
    className: k
  }, e.createElement("div", {
    className: q
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, v) : e.createElement(e.Fragment, null, v)), e.createElement("div", {
    className: S
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, f) : e.createElement(e.Fragment, null, f)))), e.createElement("div", {
    className: P
  }), e.createElement("div", {
    className: Z
  }, e.createElement("div", {
    className: B
  }, e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, i)), e.createElement("div", {
    className: H
  }, e.createElement("div", {
    className: T
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, s) : e.createElement(e.Fragment, null, s)), e.createElement("div", {
    className: N
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, c) : e.createElement(e.Fragment, null, c))), e.createElement("div", {
    className: k
  }, e.createElement("div", {
    className: q
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, p) : e.createElement(e.Fragment, null, p)), e.createElement("div", {
    className: S
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, O) : e.createElement(e.Fragment, null, O)))), e.createElement("div", {
    className: P
  }), e.createElement("div", {
    className: D
  }, e.createElement("div", {
    className: B
  }, e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, a)), e.createElement("div", {
    className: H
  }, e.createElement("div", {
    className: T
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, _) : e.createElement(e.Fragment, null, _)), e.createElement("div", {
    className: N
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, u) : e.createElement(e.Fragment, null, u))), e.createElement("div", {
    className: k
  }, e.createElement("div", {
    className: q
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, h) : e.createElement(e.Fragment, null, h)), e.createElement("div", {
    className: S
  }, b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, L) : e.createElement(e.Fragment, null, L))))), e.createElement("div", {
    className: Q
  }, e.createElement("div", {
    className: z
  }, "Powered By", b ? e.createElement("a", {
    href: b,
    target: "_blank",
    rel: "noreferrer"
  }, e.createElement("span", {
    className: J
  })) : e.createElement("span", {
    className: J
  })), o && e.createElement("div", {
    className: U
  }, e.createElement("a", {
    href: t,
    target: "_blank",
    rel: "noreferrer"
  }, e.createElement("div", {
    className: G
  }, o)))), e.createElement("div", {
    className: V
  }, e.createElement("table", null, e.createElement("tbody", null, e.createElement("tr", {
    className: F
  }, e.createElement("th", null, "Records"), e.createElement("th", {
    className: j,
    dangerouslySetInnerHTML: {
      __html: y
    }
  }), e.createElement("th", {
    className: "".concat($, " ").concat(j),
    dangerouslySetInnerHTML: {
      __html: x
    }
  })), g.map(function (d) {
    return e.createElement("tr", {
      key: d.id
    }, e.createElement("td", null, d.record), e.createElement("th", null, d.away), e.createElement("th", null, d.home));
  }))))));
};
W.propTypes = {
  title: E.PropTypes.string,
  ctaLink: E.PropTypes.string,
  ctaText: E.PropTypes.string,
  OddsTitle1: E.PropTypes.string,
  OddsTitle2: E.PropTypes.string,
  OddsTitle3: E.PropTypes.string,
  AwayShortName1: E.PropTypes.string,
  AwayShortName2: E.PropTypes.string,
  AwayShortName3: E.PropTypes.string,
  AwayOdds1: E.PropTypes.string,
  AwayOdds2: E.PropTypes.string,
  AwayOdds3: E.PropTypes.string,
  HomeShortName1: E.PropTypes.string,
  HomeShortName2: E.PropTypes.string,
  HomeShortName3: E.PropTypes.string,
  HomeOdds1: E.PropTypes.string,
  HomeOdds2: E.PropTypes.string,
  HomeOdds3: E.PropTypes.string,
  recordHomeTitle: E.PropTypes.string,
  recordAwayTitle: E.PropTypes.string,
  recordData: E.PropTypes.arrayOf(E.PropTypes.shape({
    id: E.PropTypes.number.isRequired,
    record: E.PropTypes.string,
    away: E.PropTypes.string,
    home: E.PropTypes.string
  })),
  deepLink: E.PropTypes.string
}, W.defaultProps = {
  recordData: []
};
export { W as LiveOdds, W as default };